import React from 'react';
import './movements-wall-chart.scss';
import HeaderRow from './components/team-member-row/HeaderRow';
import { Accordian } from '@shared/animations/AnimationVariants';
import { TeamWithMovements, WhereaboutsGroupType } from '@features/whereabouts/models/movements.models';
import { EditTeamControlsRow } from "@features/whereabouts/pages/team-movements/components/edit-team-row/EditTeamRow";
import { useDispatch } from "react-redux";
import { expandTeamMovements } from '@features/whereabouts/store/companyMovements.duck';
import { MediumLoadingSpinner } from "../../atoms/LoadingSpinner";
import { Center } from "../../atoms/StructuralLayout";
import EmptyTeamView from "./components/empty-team-view/EmptyTeamView";
import MovementsList from "./components/team-movements-list/MovementsList";
import RestrictedTeamView from "./components/empty-team-view/RestrictedTeamView";

interface TeamWallChartProps {
  movementsViewObject: TeamWithMovements;
  disableAccordian: boolean;
  enabledSetMovements: boolean;
  showHeader?: boolean;
  showFooter?: boolean;
  hasWeekNotesEnabled?: boolean;
  excludeCurrentUser?: boolean;
}

export function TeamWallChart(props: TeamWallChartProps) {
  const {movementsViewObject, disableAccordian, enabledSetMovements} = props;
  const dispatch = useDispatch();

  const onVisibilityStateChange = (val: boolean) => {
    if (!disableAccordian) {
      dispatch(expandTeamMovements({
        team: movementsViewObject,
        visibility: val,
      }));
    }
  }

  return (
    <React.Fragment>
      {(!disableAccordian || props.showHeader) && <HeaderRow team={movementsViewObject.team}
                                                             disableDropdown={disableAccordian}
                                                             defaultIsOpen={movementsViewObject.visible || !!props.showHeader}
                                                             showWeekNotesButton={!!props.hasWeekNotesEnabled}
                                                             teamHasWeekNotesToView={movementsViewObject.hasWeekNotes}
                                                             onOpen={onVisibilityStateChange}/>}

      <Accordian isOpen={movementsViewObject.visible} className="wallchart__team">
        {movementsViewObject.movementsLoaded && movementsViewObject.movements ?
          <>
            {movementsViewObject.restricted ? <>
              <RestrictedTeamView />
            </> : <>
              {movementsViewObject.movements.length > 0 ?
                <MovementsList movements={movementsViewObject.movements}
                               groupId={WhereaboutsGroupType.Team}
                               excludeCurrentUser={props.excludeCurrentUser}
                               enableSetMovements={enabledSetMovements}/> :
                <EmptyTeamView team={movementsViewObject.team}/>
              }
            </>}
            {props.showFooter && <EditTeamControlsRow team={movementsViewObject.team} showTeamDetails={true} />}
          </>
          :
          <Center style={{marginTop: 16}}>
            <MediumLoadingSpinner hideBorder={true} />
          </Center>
        }
      </Accordian>
    </React.Fragment>
  )
}
